"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CM_FSAMinReduce = exports.CM_FSAMinInvest = exports.CM_Per_Contract_Price = exports.CM_FSA_coinToDisplay = exports.CM_FSASupportQuotes = exports.CM_FSASupportCoins = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const CMCoinSuffix = ".CMSWAP";
const CMCoinSuffixLenght = CMCoinSuffix.length;
exports.CM_FSASupportCoins = [
    {
        spotCoin: "BTC",
        swapCoin: "BTC" + CMCoinSuffix,
        displayName: "BTC",
    },
    {
        spotCoin: "ETH",
        swapCoin: "ETH" + CMCoinSuffix,
        displayName: "ETH",
    },
    {
        spotCoin: "BNB",
        swapCoin: "BNB" + CMCoinSuffix,
        displayName: "BNB",
    },
];
exports.CM_FSASupportQuotes = [
    {
        spotCoin: "USDT",
        swapCoin: "USD",
        displayName: "USDT",
    },
    {
        spotCoin: "BUSD",
        swapCoin: "USD",
        displayName: "BUSD",
    },
    {
        spotCoin: "USDC",
        swapCoin: "USD",
        displayName: "USDC",
    },
];
const CM_FSA_coinToDisplay = (coin) => {
    if (coin.endsWith(CMCoinSuffix)) {
        return coin.substr(0, coin.length - CMCoinSuffixLenght);
    }
    return coin;
};
exports.CM_FSA_coinToDisplay = CM_FSA_coinToDisplay;
// 合约单张价格
const CM_Per_Contract_Price = (coin) => {
    switch (coin) {
        case "BTC":
        case "BTC.CMSWAP":
            return new trade_utils_lib_1.SafeDecimal(100);
        default:
            return new trade_utils_lib_1.SafeDecimal(10);
    }
};
exports.CM_Per_Contract_Price = CM_Per_Contract_Price;
const CM_FSAMinInvest = (coin) => {
    // 最小投资额：BTC定义为最少投资2张比本位合约, 其他都暂定100为10张.
    // BTC：200 U
    // 其他：100 U
    if (coin.spotCoin === "BTC") {
        return 200;
    }
    else {
        return 100;
    }
};
exports.CM_FSAMinInvest = CM_FSAMinInvest;
/**
 * 最小减仓金额
 * @param coin
 */
const CM_FSAMinReduce = (coin) => {
    const perContract = (0, exports.CM_Per_Contract_Price)(coin.spotCoin);
    return perContract.toString();
};
exports.CM_FSAMinReduce = CM_FSAMinReduce;
